import React from 'react';

export default function Support() {
  return (
    <div className="profile-section">
      <h3 className="profile-section-title">Support</h3>

      <div className="support-grid">
        <div className="support-card">
          <span className="support-icon">❓</span>
          <h4>FAQ</h4>
          <p>Find answers to common questions.</p>
          <a
            href="https://prediction-market-api.railway.app/faq"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
          >
            View FAQ
          </a>
        </div>

        <div className="support-card">
          <span className="support-icon">💬</span>
          <h4>Contact Support</h4>
          <p>Get help from our support team.</p>
          <a href="mailto:support@smartpredictions.app" className="btn-secondary">
            Email Support
          </a>
        </div>

        <div className="support-card">
          <span className="support-icon">📚</span>
          <h4>Help Center</h4>
          <p>Browse guides and tutorials.</p>
          <a
            href="https://prediction-market-api.railway.app/help"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
          >
            Help Center
          </a>
        </div>
      </div>
    </div>
  );
}
